import { Button, BUTTONTYPE } from "src/components/atoms/Button";
import closeIcon from "src/assets/icons/close.svg";
import styles from "./styles.module.css";

type Props = {
  title?: string;
  message?: string;
  itemName?: string;
  confirmText?: string;
  cancelText?: string;
  isDeleting?: boolean;
  loadingText?: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const DeleteConfirmModal: React.FC<Props> = ({
  title = "Delete item",
  message = "This action cannot be undone.",
  itemName,
  confirmText = "Delete",
  cancelText = "Cancel",
  isDeleting = false,
  loadingText = "Deleting...",
  onCancel,
  onConfirm,
}) => (
  <>
    <div className={styles.overlay} onClick={onCancel} />
    <div className={styles.modal} role="dialog" aria-modal="true">
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <button
          className={styles.closeButton}
          type="button"
          onClick={onCancel}
          aria-label="Close"
        >
          <img src={closeIcon} alt="" />
        </button>
      </div>

      <div className={styles.content}>
        {itemName && <div className={styles.itemName}>{itemName}</div>}
        <p className={styles.message}>{message}</p>
      </div>

      <div className={styles.footer}>
        <Button
          text={cancelText}
          btnType={BUTTONTYPE.BG_WHITE}
          onClick={onCancel}
          disabled={isDeleting}
          classname={styles.cancelButton}
        />
        <Button
          text={isDeleting ? loadingText : confirmText}
          btnType={BUTTONTYPE.BG_WARNING}
          onClick={onConfirm}
          disabled={isDeleting}
          classname={styles.deleteButton}
        />
      </div>
    </div>
  </>
);
